import React, { useEffect } from "react";
import "../styles/delete-account-modal.css";

type AthleteDeleteAccountModalProps = {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    loading?: boolean;
    error?: string | null;
};

export default function AthleteDeleteAccountModal({
    open,
    onClose,
    onConfirm,
    loading = false,
    error = null
}: AthleteDeleteAccountModalProps) {
    useEffect(() => {
        const onKey = (e: KeyboardEvent) => {
            if (open && e.key === "Escape" && !loading) {
                onClose();
            }
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [open, onClose, loading]);

    if (!open) return null;

    const handleBackdropClick = (e: React.MouseEvent) => {
        // Don't close when clicking backdrop - only via X or Cancel button
        e.stopPropagation();
    };

    return (
        <div className="delete-account-modal-backdrop" onClick={handleBackdropClick}>
            <div className="delete-account-modal" onClick={(e) => e.stopPropagation()}>
                <div className="delete-account-modal-header">
                    <h2>Delete Your Account?</h2>
                    <button
                        className="delete-account-modal-close"
                        onClick={onClose}
                        aria-label="Close"
                        disabled={loading}
                    >
                        ×
                    </button>
                </div>

                <div className="delete-account-modal-content">
                    {error && (
                        <div style={{
                            backgroundColor: '#fee2e2',
                            border: '1px solid #dc2626',
                            borderRadius: '8px',
                            padding: '12px 16px',
                            marginBottom: '20px',
                            color: '#991b1b',
                            fontSize: '14px'
                        }}>
                            <strong>Error: </strong>{error}
                        </div>
                    )}

                    <p className="delete-account-modal-message">
                        <strong>This action is permanent and cannot be undone.</strong>
                    </p>

                    <p className="delete-account-modal-message">
                        Deleting your account will permanently remove:
                    </p>

                    <ul style={{
                        marginLeft: '20px',
                        marginBottom: '20px',
                        color: '#374151',
                        fontSize: '16px',
                        lineHeight: '1.7'
                    }}>
                        <li>Your profile and personal information</li>
                        <li>College lists and notes</li>
                        <li>Consulting sessions</li>
                        <li>Tasks and reminders</li>
                        <li>All associated data</li>
                    </ul>

                    <p className="delete-account-modal-contact">
                        If you need assistance, please contact{' '}
                        <a href="mailto:support@polarisathlete.com" className="delete-account-modal-email">
                            support@polarisathlete.com
                        </a>.
                    </p>

                    <div className="delete-account-modal-actions">
                        <button
                            className="delete-account-cancel-btn"
                            onClick={onClose}
                            disabled={loading}
                        >
                            Cancel
                        </button>
                        <button
                            className="delete-account-confirm-btn"
                            onClick={onConfirm}
                            disabled={loading}
                        >
                            {loading ? 'Deleting...' : 'Yes, delete my account'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

